import { Alert, Col, Row, Steps } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  RegisterParams,
  Enterprise,
  registerMemberAsync,
} from '../../modules/auth';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import {
  getMemberInvitationInfo,
  requestAuthCode,
  verifyAuthCode,
} from '../../api/constlink';
import JoinMemberStep1 from '../../components/auth/JoinMemberStep1';
import JoinMemberStep2 from '../../components/auth/JoinMemberStep2';
import JoinMemberStep3 from '../../components/auth/JoinMemberStep3';
import JoinMemberStep4 from '../../components/auth/JoinMemberStep4';
import VerifyUserPhone2 from '../../components/auth/VerifyUserPhone2';
import qs from 'qs';

const StyledDiv = styled.div`
  .steps-content {
    min-height: 200px;
    margin-top: 16px;
    padding-top: 80px;
    text-align: center;
    background-color: #fafafa;
    border: 1px dashed #e9e9e9;
    border-radius: 2px;
  }

  .steps-action {
    margin-top: 24px;
  }
  .steps-content {
    /* margin-top: 16px; */
    /* border: 1px dashed #303030; */
    background-color: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.65);
    /* padding-top: 80px; */
  }
`;

const { Step } = Steps;
const steps = [
  {
    title: '회원정보 입력',
  },
  {
    title: '약관 동의',
  },
  {
    title: '휴대전화번호 인증',
  },
  {
    title: '참여 동의',
  },
  {
    title: '회원가입완료',
  },
];

interface JoinMemberContainerProps {
  userData: any;
}

function JoinMemberContainer({
  match,
  history,
}: RouteComponentProps<JoinMemberContainerProps>) {
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [user, setUser] = useState<any>();
  const [authCode, setAuthCode] = useState<any>(null);
  const [verifiedAuthCode, setVerifiedAuthCode] = useState<any>(null);
  const [invitation, setInvitation] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const { token } = match.params as any;
  const { v } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  useEffect(() => {
    (async () => {
      if (token === undefined) {
        setError({
          response: { data: { message: '초대링크가 올바르지 않습니다.' } },
        });
        return;
      }

      if (v === undefined) {
        setError({
          response: { data: { message: '초대링크가 올바르지 않습니다.' } },
        });
        return;
      }

      try {
        const _invitation = await getMemberInvitationInfo({
          token: token,
          v: v,
        });
        setInvitation(_invitation);
        setError(null);
      } catch (error) {
        setError(error);
        setInvitation(null);
      }
    })();
  }, [token, v]);

  const handlePrevStep = useCallback(() => {
    setStep(step - 1);
  }, [step]);

  const onFinishStep1 = (data: any) => {
    setUser({ ...data });

    setStep(step + 1);
  };

  const onFinishStep2 = (data: any) => {
    setUser({ ...user, ...data });

    setStep(step + 1);
  };

  const moveToMainPage = (enterpriseId: string) => {
    history.push(`/enterprises/${enterpriseId}/main`);
  };

  const _requestAuthCode = async (data: any) => {
    try {
      await requestAuthCode({ data });
      setAuthCode({ message: '인증코드를 요청하였습니다.', type: 'success' });
    } catch (error) {
      setAuthCode({
        message: '인증코드 요청을 실패 하였습니다.',
        type: 'danger',
      });
    }
  };

  const _verifyAuthCode = async (data: any) => {
    try {
      await verifyAuthCode({ data });
      setVerifiedAuthCode({
        message: '휴대전화 인증 성공 하였습니다. 아래 다음 버튼을 클릭하세요.',
        type: 'success',
      });
    } catch (error) {
      setVerifiedAuthCode({
        message: '휴대전화 인증 실패 하였습니다.',
        type: 'danger',
      });
    }
  };

  const onSuccess = async (_enterprise: Enterprise) => {
    // setEnterprise({ ..._enterprise });
    // const params: RegisterParams = {
    //   user,
    //   enterprise: { ...enterprise, ..._enterprise, type1: '1' },
    //   applicationId: queryStringData.applicationId,
    //   token: queryStringData.token,
    // };
    // dispatch(registerAdminAsync.request(params));
    // setStep(step + 1);

    const params: RegisterParams = {
      user: { ...user },
      token: token as string,
    };
    dispatch(registerMemberAsync.request(params));
    setStep(step + 1);
  };

  const updateUserPhone = async (personalPhone: string) => {
    setUser({ ...user, personalPhone });

    // 초대된 직원 등록
    // if (queryStringData.enterpriseId !== undefined) {
    //   const params: RegisterParams = {
    //     user: { ...user, personalPhone },
    //     enterpriseId: queryStringData.enterpriseId,
    //     token: queryStringData.token,
    //   };
    //   dispatch(registerMemberAsync.request(params));
    //   setStep(step + 3);
    //   return;
    // }

    setStep(step + 1);
  };

  const moveToLoginPage = () => {
    history.push('/login');
  };

  return (
    <StyledDiv>
      {error && (
        <Alert
          message={`${error.response?.data.message}`}
          type="error"
          showIcon
        />
      )}
      {invitation !== null && (
        <>
          <Row justify="center" style={{ marginTop: '10px' }}>
            <Col span={18}>
              <Steps current={step}>
                {steps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
            </Col>
          </Row>
          <div>
            {step === 0 && <JoinMemberStep1 onSuccess={onFinishStep1} />}

            {step === 1 && (
              <JoinMemberStep2
                user={user}
                onSuccess={onFinishStep2}
                onPrev={() => {
                  handlePrevStep();
                }}
              />
            )}

            {step === 2 && (
              <VerifyUserPhone2
                user={user}
                authCode={authCode}
                verifiedAuthCode={verifiedAuthCode}
                successBtnMsg={'다음'}
                requestAuthCode={_requestAuthCode}
                verifyAuthCode={_verifyAuthCode}
                onPrev={() => {
                  handlePrevStep();
                }}
                updateUserPhone={updateUserPhone}
              />
            )}
            {step === 3 && (
              <JoinMemberStep3 invitation={invitation} onSuccess={onSuccess} />
            )}
            {step === 4 && (
              <JoinMemberStep4
                moveToMainPage={moveToMainPage}
                moveToLoginPage={moveToLoginPage}
              />
            )}
          </div>
        </>
      )}
    </StyledDiv>
  );
}

export default JoinMemberContainer;
